<template>
	<li>
		<button type="button" class="uk-accordion-title">{{ displayNumber }}. Murphy Bed Mattresses</button>
		<div class="uk-accordion-content">
			<div class="ww-mtx ww-mtx--builder">
				<div class="ww-mtx__box">
				<div class="ww-mtx__slider">
					<div class="ww-mtx__track" role="radiogroup" aria-label="Mattress options">
						<button type="button" v-for="mattress in mattresses" class="ww-mtx__card" :key="'mattress_' + mattress.id" role="radio" :aria-checked="mattressIsSelected(mattress) ? 'true' : 'false'" :aria-labelledby="'mattress-name-' + mattress.id" @click.prevent="toggleMattress(mattress)" :class="{'is-selected': mattressIsSelected(mattress)}">
							<span class="ww-mtx__header">
								<span v-if="mattress.is_popular" class="ww-mtx__badge">Most Popular</span>
								<span class="ww-mtx__name" :id="'mattress-name-' + mattress.id">{{ mattress.name }}</span>
								<span class="ww-mtx__price">
									<span v-if="useDiscounts && mattress.price.discount_amount > 0" class="ww-mtx__price-old">{{ mattress.price.price | diffcurrency }}</span>
									{{ calculatePrice(mattress.price) | diffcurrency }}
								</span>
							</span>
							<img class="ww-mtx__img" :src="mattress.image ? mattress.image.webPath + '/200' : '/wp-content/themes/wallbeds/img/mattress-placeholder.jpg'" alt="" width="200" height="144">
							<span class="ww-mtx__stats">
								<span class="ww-mtx__stat"><span class="ww-mtx__stat-label">Profile Height:</span><span class="ww-mtx__stat-val">{{ renderHeight(mattress.height, 11) }}</span></span>
								<span class="ww-mtx__stat"><span class="ww-mtx__stat-label">Feel:</span><span class="ww-mtx__stat-val">{{ feelWord(mattress.comfort_rating) }}</span></span>
								<span v-if="coolingCount(mattress.cooling_rating)" class="ww-mtx__stat"><span class="ww-mtx__stat-label">Cooling:</span><span class="ww-mtx__stat-val ww-mtx__snowflakes" :aria-label="'Cooling rating: ' + coolingCount(mattress.cooling_rating) + ' out of 3'">
									<svg v-for="n in coolingCount(mattress.cooling_rating)" :key="'flake_' + mattress.id + '_' + n" class="ww-mtx__snowflake" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">
										<line x1="12" y1="3" x2="12" y2="21"/><line x1="4.2" y1="7.5" x2="19.8" y2="16.5"/><line x1="4.2" y1="16.5" x2="19.8" y2="7.5"/>
										<path d="M12 6 l-2 -2 M12 6 l2 -2 M12 18 l-2 2 M12 18 l2 2"/>
										<path d="M6.8 9 l-2.7 -0.4 M6.8 9 l-0.7 -2.6 M17.2 15 l2.7 0.4 M17.2 15 l0.7 2.6"/>
										<path d="M6.8 15 l-2.7 0.4 M6.8 15 l-0.7 2.6 M17.2 9 l2.7 -0.4 M17.2 9 l0.7 -2.6"/>
									</svg>
								</span></span>
							</span>
						</button>
					</div>
				</div>
				</div>
				<div class="bb-video-popup" uk-lightbox="video-autoplay: true;">
					<a class="bb-video-popup__link" href="https://www.youtube.com/watch?v=I-VKz17wxPs" aria-label="Watch video: do I need a special mattress?">
						<span class="bb-video-popup__content">
							<span class="bb-video-popup__title">
								<span class="bb-video-popup__q" aria-hidden="true">?</span>
								Do I need a special mattress?
							</span>
							<span class="bb-video-popup__text">Normal mattresses aren't built to stand in a Murphy Bed without deteriorating.</span>
							<span class="bb-video-popup__cta">Watch to learn more</span>
						</span>
						<span class="bb-video-popup__media">
							<img src="/wp-content/themes/wallbeds/img/placeholder.8fcab5a0.jpg" alt="" width="200" height="120">
							<span class="bb-video-popup__play" aria-hidden="true"></span>
						</span>
					</a>
				</div>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "Mattress",

	props: {
    displayNumber:{
      type: Number,
      default: 4
    }
  },
	components: {},
	data() {
		return {}
	},
	mounted() {

	},
	methods: {
		mattressIsSelected(mattress){
			return this.selected_mattress && this.selected_mattress.id == mattress.id;
		},
		toggleMattress(mattress){
			if(this.selected_mattress && this.selected_mattress.id == mattress.id){
				this.$store.commit('setSelectedMattress', null);
			} else {
				this.$store.commit('setSelectedMattress', mattress);
			}
		},
		renderHeight(value, def){
			if(value === null || value === undefined){
				return def + '"';
			}

			return value + '"';
		},
		feelWord(value){
			let v = (value === null || value === undefined || value === '') ? 40 : Number(value);
			if(v < 40) return "Firm";
			if(v < 70) return "Medium";
			return "Soft";
		},
		coolingCount(value){
			let n = parseInt(value, 10);
			return (n >= 1 && n <= 3) ? n : 0;
		},
		calculatePrice(price){
			if(this.useDiscounts && price.discount_amount){
				return price.price - price.discount_amount;
			}
			return price.price;
		}
	},
	computed: {
		...mapState({
			wallbed : state => state.wallbed,
			mattresses :  state => state.mattresses,
			selected_mattress : state => state.selected_mattress,
			useDiscounts: state => state.useDiscounts
		})
	},
	watch: {}
}
</script>
